// extracted by mini-css-extract-plugin
module.exports = {"root":"EmbedGameWrapper_root_prAs6","frame":"EmbedGameWrapper_frame_1Mqke","content":"EmbedGameWrapper_content_3oU5Y"};